import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';

/**
 * PosCloudConfigurationService (Angular 18) — POS Cloud configuration per
 * terminal.
 *
 * Replaces apps/b2b-ui/common/services/posCloudConfiguration/posCloudConfiguration.service.js.
 *
 * Endpoint base hardcoded to /v2/api/configuration/pos (legacy provider's
 * setEndpoint() value).
 *
 * Response shape — IMPORTANT
 * --------------------------
 * Legacy service called `.then(UtilsService.unwrapAcmeResponse)` on every
 * request, returning the UNWRAPPED payload `T` (not `{ data: T }`). The
 * 1 legacy TS consumer (SettingsTerminalsController.ts) reads the response
 * directly. Mirrored here: every method returns `Promise<T>`.
 */
const BASE = '/v2/api/configuration/pos';

@Injectable({ providedIn: 'root' })
export class PosCloudConfigurationService {
  private readonly http = inject(HttpClient);

  private unwrap<T = unknown>() {
    return map((body: { payload: T }) => body.payload);
  }

  getByTerminalId(terminalId: number | string): Promise<unknown> {
    return firstValueFrom(this.http.get<{ payload: unknown }>(`${BASE}/${terminalId}`).pipe(this.unwrap()));
  }

  getConfigurationByTerminalId(terminalId: number | string): Promise<unknown> {
    return firstValueFrom(
      this.http
        .get<{ payload: unknown }>(`${BASE}/${terminalId}/configuration`, {
          params: { contentType: 'application/json' },
        })
        .pipe(this.unwrap()),
    );
  }

  upload(terminalId: number | string, configuration: unknown): Promise<unknown> {
    return firstValueFrom(
      this.http.post<{ payload: unknown }>(BASE, { terminalId, configuration }).pipe(this.unwrap()),
    );
  }
}
